import { getCatalogueTags, inStockTagExists, onSaleTagExists } from './Catalogue';
import { getProduct } from './Product';
import { shouldShowOutOfStockBadge } from './Inventory';
import EventBus from './EventBus';
import { USER_TAG_SUFFIX } from '../../config';
import I18n from './I18n';
import { getSelectedFilters, setSelectedFilters } from './Filters';
import { tagsFilterKey } from '../organisms/CatalogueFilters/helpers';
import { findIndexInArray } from '../../../utils/GlobalUtils';
import { MORE_PRODUCTS_TITLE } from './Utils';

export const ON_SALE_TAG_KEY = 'on_sale';

export const getVisibleTags = () => getCatalogueTags();

export const getSelectedTags = () => {
  const filters = getSelectedFilters() || {};
  return filters[tagsFilterKey] || [];
};

export const getTags = () => {
  const tags = getVisibleTags();
  const showOnSaleTag = onSaleTagExists();
  const showInStockTag = inStockTagExists();
  const selectedTags = getSelectedTags();

  if (selectedTags.length || tags.length || showOnSaleTag || showInStockTag) {
    const prefixTags = [];
    prefixTags.push(I18n.t('TAG_ALL'));

    if (showOnSaleTag) {
      prefixTags.push(I18n.t('ON_SALE'));
    }

    if (showInStockTag) {
      prefixTags.push(I18n.t('IN_STOCK'));
    }

    return [...prefixTags, ...tags.map(tag => `${tag}${USER_TAG_SUFFIX}`)];
  }

  return [];
};

const setTags = tags => {
  const copiedSelectedFilters = { ...(getSelectedFilters() || {}) };

  if (!tags && !tags.length) {
    delete copiedSelectedFilters[tagsFilterKey];
    setSelectedFilters(copiedSelectedFilters);
    return;
  }
  setSelectedFilters({
    ...copiedSelectedFilters,
    [tagsFilterKey]: tags
  });
};

export const setSelectedTags = tags => {
  if (tags === null || tags === undefined) {
    setTags([]);
    return;
  }
  if (!Array.isArray(tags)) {
    return;
  }

  setTags(tags);
};

export const getSelectedTagsForApi = () => {
  let selectedTags = getSelectedTags();

  selectedTags = selectedTags
    .map(selectedTag => {
      // removing all, instock, on sale tags
      if (isAllTag(selectedTag) || isInStockTag(selectedTag) || isOnSaleTag(selectedTag)) {
        return '';
      }
      return getDisplayTag(selectedTag);
    })
    .filter(tag => tag);

  if (!selectedTags || !selectedTags.length) {
    return null;
  }

  return selectedTags;
};

export const findIndexOfSelectedTag = tag =>
  findIndexInArray(
    getSelectedTags(),
    selectedTag =>
      selectedTag === tag ||
      selectedTag === tag.replace(USER_TAG_SUFFIX, '') ||
      selectedTag.replace(USER_TAG_SUFFIX, '') === tag
  );

export const isTagSelected = tag => findIndexOfSelectedTag(tag) !== -1;

export const toggleTagOnProductClick = tag => {
  if (tag && tag !== getSelectedTags()) {
    if (tag === MORE_PRODUCTS_TITLE) {
      resetFilters();
    } else if (isAllTag(tag) || isInStockTag(tag) || isOnSaleTag(tag)) {
      toggleTag(tag);
    } else {
      toggleTag(`${tag}${USER_TAG_SUFFIX}`);
    }
  }
};

export const toggleTag = tag => {
  const index = findIndexOfSelectedTag(tag);

  let selectedTags = [...getSelectedTags()];
  // if all tag clicked to select remove all others if selected any
  if (index === -1) {
    selectedTags.push(tag);
    if (isAllTag(tag)) {
      selectedTags = [tag];
    } else {
      selectedTags = selectedTags.filter(selectedTag => !isAllTag(selectedTag));
    }
  } else {
    selectedTags.splice(index, 1);
  }

  setTags(selectedTags);

  EventBus.notify(EventBus.TYPE.SELECTED_TAG_FILTER_CHANGED, selectedTags);
  EventBus.notify(EventBus.TYPE.SELECTED_TAG_CHANGED, tag);
};

export const isAllTag = tag => tag === I18n.t('TAG_ALL');

export const isOnSaleTag = tag => tag === I18n.t('ON_SALE');

export const isInStockTag = tag => tag === I18n.t('IN_STOCK');

export const isOnlyAllTagSelected = () => {
  const selectedTags = getSelectedTags();

  if (!selectedTags || !selectedTags.length) {
    return false;
  }

  return selectedTags.length === 1 && selectedTags[0] === I18n.t('TAG_ALL');
};

export const isAnyTagSelectedOtherThanAll = () => {
  const index = findIndexInArray(getSelectedTags(), tag => !isAllTag(tag));
  return index !== -1;
};

export const shouldShowOnSaleTag = productIds =>
  productIds.some(productId => {
    const product = getProduct(productId);

    if (!product) {
      return false;
    }

    return !(typeof product.discounted_price !== 'number' || !product.price);
  });

export const shouldShowInStockTag = productIds =>
  productIds.some(productId => !!shouldShowOutOfStockBadge(productId));

export const resetFilters = notify => {
  if (!getSelectedTags().length) {
    if (notify) {
      EventBus.notify(EventBus.TYPE.CLEAR_FILTER);
    }
    return;
  }

  setTags([]);
  EventBus.notify(EventBus.TYPE.CLEAR_FILTER);
};

export const getDisplayTag = tag =>
  tag && tag.indexOf(USER_TAG_SUFFIX) !== -1 ? tag.slice(0, -1 * USER_TAG_SUFFIX.length) : tag;

export const checkIfAllOnSaleInStockTagSelected = () => {
  const selectedTags = getSelectedTags();
  let onSaleTagSelected = false;
  let isAllTagSelected = false;
  let inStockTagSelected = false;
  selectedTags.forEach(tag => {
    if (isAllTag(tag)) {
      isAllTagSelected = true;
    } else if (isOnSaleTag(tag)) {
      onSaleTagSelected = true;
    } else if (isInStockTag(tag)) {
      inStockTagSelected = true;
    }
  });

  return { isAllTagSelected, onSaleTagSelected, inStockTagSelected };
};
